import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from "@angular/platform-browser";
import { environment } from '../../src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';

declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    environment = environment;
    checkApiLoadedInterval: any;
    checkIubendaLoadedInterval: any;

    // @HostListener('click', ['$event']) onClick($event : any){
    //     gtag('event', "click", {
    //         'type_of_click': "create-room"
    //     });
    // }

    constructor(
        private window: Window,
        private elementRef: ElementRef,
        private titleService: Title,
        private dialog: MatDialog,
        private router: Router,
    ) {
        if (environment.production) {
            // init google analytics only for production
            const gtag = (window as any)["gtag"];
            if (gtag) {
                gtag('js', new Date());
                gtag('config', environment.gtag.config1);
                this.router.events.subscribe((event) => {
                    if (event instanceof NavigationEnd) {
                        gtag('config', environment.gtag.config2, { 'page_path': event.urlAfterRedirects });
                    }
                })
            }
        }
    }

    async ngOnInit() {
        this.loadSwarmifyApi().then(() => { });
        this.loadIubenda();
        this.loadGoogleTagManager();
    }

    loadSwarmifyApi() {
        return new Promise<any>((resolve, reject) => {
            if (!environment.swarmifyLoaded) {
                const swarmifyKey = environment.configuration.swarmifyCDNKey;
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src = `https://assets.swarmcdn.com/cross/swarmdetect.js`;
                this.elementRef.nativeElement.appendChild(s);
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.text = `var swarmoptions = {
                    swarmcdnkey: "${swarmifyKey}",
                    iframeReplacement: "iframe",
                    theme: {
                        primaryColor: "#BEE530",
                    },
                    autoreplace: {
                        youtube: false
                    }
                };`;
                this.elementRef.nativeElement.appendChild(s);
                this.checkApiLoadedInterval = setInterval(() => {
                    if ((window as any).SWARMIFY_LOADED) {
                        environment.swarmifyLoaded = true;
                        clearInterval(this.checkApiLoadedInterval);
                        resolve(true);
                    }
                }, 300);
            }
            else {
                resolve(true)
            }
        });
    }

    loadIubenda() {
        return new Promise<any>((resolve, reject) => {
            if (environment.production && environment.iuBenda.enabled) {
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.text = environment.iuBenda.script1.text;
                this.elementRef.nativeElement.appendChild(s);
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src = environment.iuBenda.script2.src;
                this.elementRef.nativeElement.appendChild(s);
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src = `//cdn.iubenda.com/cs/iubenda_cs.js`;
                s.charset = "UTF-8";
                s.async = true;
                this.elementRef.nativeElement.appendChild(s);
                resolve(true);
            }
            else {
                resolve(true)
            }
        });
    }

    loadGoogleTagManager() {
        if (environment.production && environment.gtag.enabled) {
            const gtmScript = document.createElement('script');
            gtmScript.innerHTML = `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${environment.gtag.gtmIframeID}');
        `;
            document.head.appendChild(gtmScript);

            const gtmNoScript = document.createElement('noscript');
            const gtmIframe = document.createElement('iframe');
            gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${environment.gtag.gtmIframeID}`;
            gtmIframe.height = "0";
            gtmIframe.width = "0";
            gtmIframe.style.display = "none";
            gtmIframe.style.visibility = "hidden";
            gtmNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${environment.gtag.gtmIframeID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
            document.body.prepend(gtmNoScript);
        }
    }
}
